module.exports = __webpack_public_path__ + "img/asset-03.8111e2a1.svg";